import { OnInit, Component, Input, EventEmitter, Output } from '@angular/core';
import { BrandOption, BrandingData, BrandingSelectData } from 'globals/store/publish.data';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { brandDataReselector } from '../../store/reselectors/publish.reselector';
import { clipboardEditingPrivilegesReselector } from '../../store/reselectors/accounts.reselector';
import { JoiAppInfo } from 'globals/store/app.data';
import { Wrapper } from '../../components/wrapper.component';
import { ManageBrandingComponent, ManageBrandingData } from '../../components/branding/manage-branding.component';
import { BrandingBlockWrapperComponent } from 'src/app/components/branding/branding-block.component';
import { BrandTemplateComponent } from 'src/app/components/branding/brand-template.component';
import { BrandImageComponent } from 'src/app/components/branding/brand-image.component';
import { SocialLinksComponent } from 'src/app/components/social-links/social-links.component';
import { FooterLinksComponent } from 'src/app/components/branding/footer-links.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-branding',
    templateUrl: "./app-branding.html",
    styles: [`
  img.header, img.footer { cursor: pointer; margin: 0 auto; display: flex; }
  branding-block, branding-text, img.header, img.footer { margin-bottom: 40px; width: 1330px; max-width: 100%; }
  calls-to-action { margin: 20px auto 0; }
  performer-gallery { pointer-events: none; margin-bottom: -30px; }
  .sponsors-holder { display: flex; flex-wrap: wrap; justify-content: space-around; margin-top: 20px; }
  sponsor-gallery-card { margin: 0 20px 20px; }
  brand-template { margin-top: 40px; }
`],
    standalone: true,
    imports: [BrandingBlockWrapperComponent, BrandTemplateComponent, BrandImageComponent, SocialLinksComponent, FooterLinksComponent, CommonModule],
})
export class AppBrandingComponent extends Wrapper<AppBrandingComponent> implements OnInit {
  brandingData: BrandingData
  @Input() appInfo: JoiAppInfo
  canEditAccount: boolean

  ngOnInit() {
    const brandingSelectData: BrandingSelectData = {
      type: 'app',
      appId: this.appInfo.id,
    }
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')
    this.selectProp(clipboardEditingPrivilegesReselector, null, 'canEditAccount')
  }

  constructor() {
    super()
  }

  async editBranding(brandingOption: BrandOption) {
    console.log("Should be opening branding options dialogue and changing " + brandingOption)
    const data: ManageBrandingData = { selectedTab: brandingOption, type: 'app', appId: this.appInfo.id, onAccount: this.canEditAccount }
    await openDialogGetResult(this.dialog, ManageBrandingComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
  }

}